

























































































































































import { Component, Inject, Prop } from 'vue-property-decorator';
import { LessonEntity } from '@/entities/lesson.entity';
import { LessonCategoryEntity } from '@/entities/lesson-category.entity';
import LessonCategoryService from '@/services/lesson-category.service';
import { UseService } from '@/services/service';
import VuePdf from 'vue-pdf/src/vuePdfSss.vue';
import moment from 'moment';
import CDivider from '@/components/Helper/CDivider.vue';
import CreateListDataMixin, { FilterGetterFn } from '@/mixin/ListDataMixin';
import GraduationHatIcon from '@/components/Helper/Icon/Svg/GraduationHatIcon.vue';
import SurveyQuestionELearningItem from '@/components/ViewComponent/ELearning/Items/SurveyQuestionELearningItem.vue';

const filter: FilterGetterFn<Index> = (el) =>
  el.categoryId ? [['categoryId', '$eq', el.categoryId]] : [];

@Component<Index>({
  components: {
    CDivider,
    GraduationHatIcon,
    VuePdf,
    SurveyQuestionELearningItem,
  },
  filters: {
    translateDate(val, locale) {
      if (locale === 'vi') return moment(val.testResult.createdAt).format('DD/MM/YYYY');
      return moment(val.testResult.createdAt).format('YYYY/MM/DD');
    },
  },
  watch: {
    categoryId() {
      this.filter = filter(this);
      this.fetchCategory();
    },
  },
  data() {
    return {
      isSubmitSurveyQuestionResult: true,
    };
  },
  created() {
    const isSubmitSurveyQuestionResult = JSON.parse(
      localStorage.getItem('isSubmitSurveyQuestionResult'),
    );
    if (isSubmitSurveyQuestionResult) {
      this.isSubmitSurveyQuestionResult = isSubmitSurveyQuestionResult.flag;
    }
  },
})
export default class Index extends CreateListDataMixin<LessonEntity>(
  'lesson',
  'lesson',
  [],
  [['id', 'DESC']],
  20,
  filter,
) {
  @Prop({ type: [Number, String] })
  categoryId: number;

  @Inject('toggleSideDrawer')
  toggleSideDrawer!: () => any;

  // items!: LessonEntity[];

  category: LessonCategoryEntity = null;

  @UseService(LessonCategoryService)
  service: LessonCategoryService;

  isSubmitSurveyQuestionResult: boolean;

  async mounted(): Promise<void> {
    await this.fetchCategory();
  }

  async fetchCategory(): Promise<void> {
    if (!this.categoryId) {
      this.category = null;
      return;
    }
    this.category = await this.service.getOne(this.categoryId);
  }

  getLearntPercentCount(lesson: LessonEntity): number {
    const learntPages = lesson?.learnProgress?.pages || [];
    const percent = Number(learntPages.length) / (lesson.totalPage || learntPages.length);
    return percent * 100;
  }

  handleLearnLesson() {
    this.$http.get('/lesson/learn');
  }
}
